<!--实名认证-->
<template>
    <div class="user-identity-page">
        <div class="header">
            <div class="title">
                <p>{{ $t('实名认证') }}</p>
                <p style="font-size: 14px;margin: 0px;line-height: normal;">
                    {{ $t('绑定真实个人信息，防止账户盗用、篡改') }}
                </p>
            </div>
            <div class="imgTip">
                <img src="@/assets/img-pc/transferLog.svg" alt="" />
            </div>
        </div>

        <div class="identity">
            <div class="tab">
                <button class="active">{{ $t('个人认证') }}</button>
            </div>
            <div class="identity-content">
                <div class="basic">
                    <div class="basic-content">
                        <div class="left">
                            <div class="header">
                                <span>{{ $t('基础身份认证') }}</span>
                            </div>
                            <p>
                                <span><img src="@/assets/img-pc/transferLog_1.png" alt="" />{{ $t('基础身份认证') }}</span>
                                <span><img src="@/assets/img-pc/transferLog_2.png" alt="" />{{ $t('真实姓名、身份证件号码')
                                    }}</span>
                                <span><img src="@/assets/img-pc/transferLog_3.png" alt="" />{{ $t('预计1小时内完成审核')
                                    }}</span>
                            </p>
                        </div>
                        <div class="right">
							<span class="bk-btn1" v-if="status.basic_status == 1">{{ $t('已认证') }}</span>
                            <el-button class="bk-btn" @click="open(1)" v-else>{{ status.basic_status_text }}</el-button>
                        </div>
                    </div>
                </div>
                <div class="basic">
                    <div class="basic-content">
                        <div class="left">
                            <div class="header">
                                <span>{{ $t('高级实名认证') }}</span><i>{{ $t('推荐') }}</i>
                            </div>
                            <p>
                                <span><img src="@/assets/img-pc/transferLog_1.png" alt="" />{{ $t('身份证件照正、反面照片')
                                    }}</span>
                                <span><img src="@/assets/img-pc/transferLog_3.png" alt="" />{{ $t('预计2小时内完成审核')
                                    }}</span>
                            </p>
                        </div>
                        <div class="right">
                            <span class="bk-btn1" v-if="status.advanced_status == 1">{{ $t('已认证') }}</span>
                            <el-button class="bk-btn" @click="open(2)" v-else>{{ status.advanced_status_text }}</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <advancedDialog ref="advancedDialogRef"></advancedDialog>
        <basicDialog ref="basicDialogRef" @success="getData"></basicDialog>
    </div>
</template>

<script>
import {
    get
} from '@/http/request'
import advancedDialog from './components/advancedDialog.vue'
import basicDialog from './components/basicDialog.vue'
export default {
    components: {
        basicDialog,
        advancedDialog
    },
    data() {
        return {
            status: {}
        };
    },
    created() {
        this.getData()
    },
    beforeUnmount() { },
    methods: {
        getData(showLoading = true) {
            // basic_status，advanced_status这两个字段判断
            get(this.$apis.getUserRealInfo, { showLoading }).then(res => {
                if (res.code != 1) return
                this.status = res.data
            })
        },
        open(type) {
            if (type == 1 && this.status.basic_status == 3) {
                this.$refs.basicDialogRef.open()
            } else if (type == 2 && this.status.advanced_status == 3) {
                this.$refs.advancedDialogRef.open()
            }
        }
    },
};
</script>
<style lang="scss" scoped>
.user-identity-page {
    width: 75rem;
    margin: 40px auto 0;

    .header {
        background-color: #1c222c;
        border-radius: 8px;
        margin-top: 10px;
        padding: 30px 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        p {
            margin: 0px;
            font-size: 28px;
            font-weight: 700;
            line-height: 40px;
            margin-bottom: 10px;
        }
    }

    .identity {
        background-color: #1c222c;
        border-radius: 8px;
        margin-top: 10px;
        padding: 0;
        overflow: hidden;
        margin-bottom: 40px;

        .tab {
            height: 50px;

            .active {
                border: none;
                background: none;
                min-width: 144px;
                padding: 0 10px;
                height: 100%;
                font-size: 16px;
                font-weight: 700;
                color: #333;
                cursor: pointer;
                background-color: #282e39;
                border-top: 2px solid #282e39;
                color: #fff;
            }
        }

        .identity-content {
            padding: 40px;

            .basic {
                padding-bottom: 36px;
                border-bottom: 1px solid hsla(0, 0%, 56.9%, .1);

                .basic-content {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .left {
                        .header {
                            height: 40px;
                            overflow: hidden;
                            padding: 15px 30px;
                            display: inline-flex;

                            i {
                                font-style: normal;
                                padding: 0 8px;
                                background-color: rgba(236, 109, 86, .1);
                                color: #ec6d56;
                                font-size: 12px;
                                font-weight: 700;
                                line-height: 18px;
                                float: left;
                                height: 18px;
                                margin: 5px 0 0 8px;
                            }

                            span {
                                line-height: 28px;
                                font-size: 20px;
                                font-weight: 700;
                                height: 28px;
                                float: left;
                            }
                        }

                        p:last-child {
                            min-height: 28px;
                            overflow: hidden;
                            box-sizing: content-box;
                            margin-bottom: 0px;

                            span {
                                font-size: 14px;
                                font-weight: 500;
                                line-height: 28px;
                                float: left;
                                padding-right: 45px;
                                position: relative;
                                display: flex;

                                img {
                                    margin-right: 5px;
                                }
                            }
                        }
                    }

                    .right {
                        .bk-btn {
                            padding: 12px 10px;
                            min-width: 100px;
                            font-size: 16px;
                            border-radius: 4px;
                            font-weight: 700;
                            border: none;
                            float: left;
                            background: #f0c163 !important;
                            color: rgb(27, 179, 6);
                        }
						
						.bk-btn1 {
							color: rgb(27, 179, 6);
						}
                    }
                }
            }
        }
    }
}
</style>